import React from 'react';
import PropTypes from 'prop-types';

import CheckboxLabel from 'common/components/elements/inputs/checkbox-label';
import './style.scss'
import Icon from 'common/components/elements/icons';
import Switch from 'common/components/elements/inputs/switch';
import CommentPermissionModal from 'common/components/modules/comments-permission-modal';

function AccessSettings({
   filters,
   onToggleFilter,
   statisticsData,
   hideStory,
   hideStoryValue,
   onChangePermission,
   commentPermission,
   isShowHideAfter,
   isMobile,
}) {
   const toggleFilter = (bool, item) => {
      onToggleFilter(bool, item)
   };
   return (
      <div className='w-full flex flex-col pt-6 relative'>
         <div className='pb-10 select-none'>
            <span className='text-major text-2xl leading-relaxed ml-4'>Who can view this story?</span>
            <div className='my-4 filter-items border-t border-divider'>
               <AccessItem
                  isActive={ true }
                  name='Active members'
                  description='Active paying members Includes'
                  count={ statisticsData.active }
                  cancelledCount={ statisticsData.cancelled }
                  iconBgColor='success'
                  onChange={ (name, value) => toggleFilter(value, 'active') }
                  checked={ filters.includes('active') }
               />
               <AccessItem
                  isActive={ false }
                  name='Public'
                  description='Site visitors without active memberships'
                  iconBgColor=' skin-secondary-background'
                  onChange={ (name, value) => toggleFilter(value, 'public') }
                  checked={ filters.includes('public') }
               />
            </div>
            <div className='px-4 my-3 flex'>
               <CommentPermissionModal
                  permission={ commentPermission }
                  onChangePermission={ onChangePermission }
                  isMobile={ isMobile }

               />
            </div>
            {
               isShowHideAfter && (
                  <div className='cursor-pointer border-2 rounded-lg mx-4 flex'>
                     <CheckboxLabel
                        name='hide_story'
                        label='Hide after 24 hours'
                        onChange={ hideStory }
                        textColor='secondary'
                        checked={ hideStoryValue }
                        position='left'
                     />
                  </div>
               )
            }
         </div>
      </div>
   );
}
const AccessItem = ({
   iconBgColor,
   isActive,
   name,
   description,
   count,
   cancelledCount,
   onChange,
   checked,
}) => {
   return (
      <div className='flex p-4 bg-panel border-b border-divider justify-between items-baseline'>
         <div className='flex mr-3 flex-1'>
            <div
               style={ {
                  minWidth: '28px',
               } }
               className={ `h-7 w-7 flex items-center justify-center bg-${ iconBgColor } rounded-full mr-3` }>
               <Icon
                  name={ isActive ? 'group' : 'public' }
                  color='major-dark'
                  size='lg'
               />
            </div>
            <div className='flex flex-col'>
               <span style={ {
                  lineHeight: '24px',
               } }>
                  <span className='text-gery-yoda text-xl font-bold'>{name}</span> {isActive && (
                     <span className='font-medium text-secondary'> • {count}</span>
                  )}
               </span>
               <span className='text-placeholder text-sm mt-1'>
                  {description}
                  {
                     isActive && (
                        <span className='font-medium'> {cancelledCount} cancelled memberships</span>
                     )
                  }
               </span>
            </div>
         </div>
         <Switch
            onChange={ onChange }
            checked={ checked }
            className='stream_enabled_switch'
         />
      </div>
   )
}

AccessSettings.propTypes = {
   onToggleFilter: PropTypes.func,
   filters: PropTypes.array,
   statisticsData: PropTypes.object,
   hideStory: PropTypes.func,
   hideStoryValue: PropTypes.bool,
   onChangePermission: PropTypes.func,
   commentPermission: PropTypes.string,
   isShowHideAfter: PropTypes.bool,
   isMobile: PropTypes.bool,
};
AccessItem.propTypes = {
   iconBgColor: PropTypes.string,
   isActive: PropTypes.bool,
   checked: PropTypes.bool,
   name: PropTypes.string,
   description: PropTypes.string,
   count: PropTypes.any,
   onChange: PropTypes.func,
   cancelledCount: PropTypes.any,
};

export default React.memo(AccessSettings);
